<script setup>
import { defineEmits, defineProps, toRefs } from "vue"
import TextareaType from "@/components/Blocks/Types/TextareaType.vue";
import HeaderType from "@/components/Blocks/Types/HeaderType.vue";
import TinymceType from "@/components/Blocks/Types/TinymceType.vue";
import ImageType from "@/components/Blocks/Types/ImageType.vue";
import ColumnType from "@/components/Blocks/Types/ColumnType.vue";

const emit = defineEmits(['saveBlock'])

const props = defineProps({
  length: {},
	isColumn: {
		type: Boolean,
		default: false
	},
	competitionId: {
		type: [String, Number],
		required: true
	}
});
const {length, competitionId} = toRefs(props);

function addBlock(object) {
  emit('saveBlock', object)
}
</script>

<template>
  <div class="blocks_container">
    <HeaderType @save-block="addBlock" :length="length" />
    <TextareaType @save-block="addBlock" :length="length" />
    <TinymceType @save-block="addBlock" :length="length" />
    <ImageType :competition-id="competitionId" @save-block="addBlock" :length="length"/>
    <ColumnType v-if="!isColumn" @save-block="addBlock" :length="length"/>
  </div>
</template>

<style lang="scss" scoped>
.blocks_container {
  display: flex;
  gap: 8px;
	flex-wrap: wrap;
}
</style>